// /**
//  * Zones - Add
//  */

// React
import React, {useState} from 'react';

// react hook form
import {useForm} from 'react-hook-form';
// UI
import {
  TextField,
  Grid,
  Button,
  CardHeader,
  CardContent,
  Card,
  Typography,
  CircularProgress,
  DialogTitle,
  Dialog,
  DialogActions,
  IconButton,
  Paper,
  Divider,
} from '@material-ui/core';

import classes from './add.module.scss';

// Icon
import Icon from '@mdi/react';
import {mdiClose} from '@mdi/js';
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';
import {Store} from '../../../../redux/reducers';
import {
  makeSelectSellersList,
  makeSelectCountList,
  makeSelectError,
  makeSelectLoading,
} from '../.././selectors';
import {
  createSellerAction,
  getSellersAction,
  updateSellerStatus,
} from '../.././actions';
import {Payload, PayloadCreate, State} from '../../interfaces';

// helpers
import {flattenObject, removeEmptyValueObject} from '../../../../utils/helpers';
import useQuery from '../../../../utils/hook/useQuery';

// Type
import {addSeller} from '../../interfaces';

type Props = {
  createSeller: (body: addSeller) => void;
  count: number;
  error: any;
  onClose: () => void;
};

type Inputs = {
  name: string;
  code: string;
};

function AddMobile(props: Props) {
  const {register, handleSubmit, watch, errors} = useForm<Inputs>();
  const onSubmit = ({name, code}: Inputs) => {
    handleCreateSeller({
      name,
      code,
    });
  };
  const [checkAddSeller, setCheckAddSeller] = useState(false as boolean);
  const [openAddModal, setOpenAddModal] = useState(false as boolean);
  const [formData, setFormData] = useState(null as null | addSeller);
  const {filtersValues, setFiltersValues} = useQuery({
    partnerId: {equals: localStorage.getItem('partnerId')},
    page: 0,

    size: 10,
  });

  const handleSubmitAddSeller = () => {
    const callback = () => {
      setCheckAddSeller(false);
      setOpenAddModal(false);
      setFormData(null);
    };
    const {name, code}: addSeller = formData!;
    props.createSellerDispatch({
      body: {
        name: name,
        code: code,
      },
      pagination: filtersValues,
      callback,
    });
  };
  const handleCreateSeller = (body: addSeller) => {
    setFormData(body);
    setCheckAddSeller(true);
  };
  const handleCloseCheck = () => {
    setCheckAddSeller(false);
    setFormData(null);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid
        style={{
          zIndex: 10,
          backgroundColor: 'white',
          position: 'fixed',
          top: '0',
          right: '71px',
        }}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={0}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '83%',
            borderRadius: '0',
            marginTop: '6px',
          }}
        >
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              {'ایجاد فروشنده'}
            </Typography>
          </div>
          <IconButton
            aria-label="close"
            style={{marginLeft: '6px'}}
            onClick={() => window.history.back()}
          >
            <Icon path={mdiClose} size={1.3} />
          </IconButton>
        </Paper>
      </Grid>
      <Grid container xs={12} lg={12} alignItems="flex-start">
        <Grid container item xs={12} lg={12} alignItems="flex-end">
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Grid>
                  <Typography className={classes.typographyCards}>
                    اطلاعات فروشنده
                  </Typography>
                </Grid>
              }
            />

            <CardContent className={classes.cardContentOrder}>
              <Grid container lg={12} md={12} className={classes.cardContent}>
                <Grid container item spacing={2} lg={12} md={12}>
                  <Grid container item xs={6} md={3} lg={3} alignItems="center">
                    <div className={classes.item}>
                      <div style={{width: '100%'}}>
                        <TextField
                          variant="outlined"
                          type="text"
                          fullWidth
                          id="name"
                          name="name"
                          label="نام فروشنده"
                          inputRef={register({
                            required: true,
                          })}
                          error={errors.name && true}
                        />
                      </div>
                    </div>
                  </Grid>
                  <Grid container item xs={6} md={3} lg={3} alignItems="center">
                    <div className={classes.item}>
                      <div style={{width: '100%'}}>
                        <TextField
                          variant="outlined"
                          type="text"
                          fullWidth
                          id="code"
                          name="code"
                          placeholder="seller-1"
                          label="کد فروشنده"
                          inputRef={register({
                            required: true,
                            pattern: {
                              value: /^[A-Za-z\d\-_]+$/,
                              message: 'مقدار وارد شده صحیح نمیباشد',
                            },
                          })}
                          error={errors.code && true}
                        />

                        {/*
            ^[A-Za-z\d\-_]+$
            */}
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Grid
        container
        lg={12}
        md={12}
        xs={12}
        style={{
          flexDirection: 'row-reverse',
          position: 'fixed',
          backgroundColor: '#fff',
          bottom: '0',
          right: '0',
          padding: '15px',
          zIndex: 2,
          borderTop: '1px solid #000',
        }}
      >
        <Grid container>
          <Button
            disabled={
              Object.keys(flattenObject(removeEmptyValueObject({...watch()})))
                .length === 0
            }
            type="submit"
            size="medium"
            data-cy="search"
            autoFocus
            variant="contained"
            color="primary"
            style={{
              flex: '1 1 0',
              padding: '10px',
            }}
          >
            {'ذخیره فروشنده'}
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="medium"
            onClick={() => window.history.back()}
            style={{
              flex: '1 1 0',
              padding: '10px',
              marginRight: '14px',
            }}
          >
            {'انصراف'}
          </Button>
        </Grid>
      </Grid>

      <Dialog
        open={checkAddSeller}
        onClose={handleCloseCheck}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            {handleCloseCheck ? (
              <IconButton aria-label="close" onClick={handleCloseCheck}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>

          <div className={classes.cancelTitle}>
            {`آیا از ایجاد کردن فروشنده ${formData?.name} اطیمنان دارید؟`}
          </div>
        </DialogTitle>
        <Divider style={{width: '100%', marginLeft: '0', marginRight: '0'}} />
        <DialogActions className={classes.actionsBox}>
          <Grid container>
            <Grid container xs={12} style={{padding: '5px 0'}}>
              <Button
                variant="contained"
                onClick={handleSubmitAddSeller}
                size="medium"
                color="primary"
                disabled={props.loading}
                style={{flex: '1 1 0', padding: '10px'}}
              >
                {props.loading ? (
                  <CircularProgress size={24} color="secondary" />
                ) : (
                  'ذخیره فروشنده'
                )}
              </Button>
              <Button
                style={{marginRight: '7px', padding: '10px', flex: '1 1 0'}}
                autoFocus
                onClick={handleCloseCheck}
                variant="outlined"
                color="primary"
                size="medium"
              >
                {'انصراف'}
              </Button>
            </Grid>
          </Grid>

          {/* <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseCheck}
                variant="contained"
                size="large"
              >
                {`خیر`}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                onClick={handleSubmitAddSeller}
                fullWidth
                variant="contained"
                size="large"
                color="secondary"
                disabled={props.loading}
              >
                {props.loading ? (
                  <CircularProgress size={24} color="secondary" />
                ) : (
                  'بله'
                )}
              </Button>
            </Grid>
          </Grid> */}
        </DialogActions>
      </Dialog>
    </form>
  );
}
const mapStateToProps = () =>
  createStructuredSelector<Store, State>({
    sellerList: makeSelectSellersList(),
    count: makeSelectCountList(),

    loading: makeSelectLoading(),
    error: makeSelectError(),
  });

function mapDispatchToProps(dispatch: Function) {
  return {
    sellersDispatch: (payload: Payload) => dispatch(getSellersAction(payload)),
    updateSellerStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
    }) => dispatch(updateSellerStatus(payload)),
    createSellerDispatch: (payload: PayloadCreate) =>
      dispatch(createSellerAction(payload)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddMobile);
